import { store, store$ } from '@redux/store';
import { selectPage } from 'features/articleSearchResultsFacets';
import { routingSelectors, routingStateActions } from 'features/routing';
import { distinctUntilChanged, filter, map } from 'rxjs';

/**
 * Returns the next location string based on whether it's the first page and the current location.
 * @param {Boolean} isFirstPage
 * @param {String} location
 * @returns {*|string}
 */
function getNextLocation(isFirstPage, location) {
  const hasSlash = location.endsWith('/');
  if (isFirstPage) {
    // in the first page we need to return a "location" with a trailing /
    // so we add it if it doesn't have it already
    return hasSlash ? location : `${location}/`;
  }
  // in the other pages we need to remove the / if it is present
  // as the `routing feature` will add it automatically even if it is already there
  return hasSlash ? location.slice(0, - 1) : location;
}


/**
 * Updates the paging component of the url.
 * Also updates the "location" component to be in the right format according to the page
 * @param {Number} pageNumber - Number of the selected page.
 */
function updateUrlPaging(pageNumber) {
  const state = store.getState();
  const location = routingSelectors.selectUrlLocation(state);
  const isFirstPage = pageNumber === 1;
  const nextLocation = getNextLocation(isFirstPage, location);

  // add "/" by business rule of the learning center (all url has / to the end)
  const nextPaging = isFirstPage ? '' : `page-${pageNumber}/`;

  store.dispatch(routingStateActions.updateLocation(nextLocation));
  store.dispatch(routingStateActions.updatePagination(nextPaging));
}

// observer to map search command but only emit if the page have been changed
const onPageChange$ = store$.pipe(
  map(selectPage),
  filter(Boolean),
  distinctUntilChanged(),
);

onPageChange$.subscribe(updateUrlPaging);

